import { Box } from '@mui/material';
import styled from 'styled-components';

export const ItemsContainer = styled(Box)`
  > div:last-child {
    margin-bottom: 0;
  }
`;
